import { FC } from 'react';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  return (
    <InnerWrapper>
      <GroupedDocsTable
        entityName="my-documents-archived"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'archived',
        }}
        hideActionsColumn
      />
    </InnerWrapper>
  );
};

export default Screen;
